import type { Bedrooms, CarryBand } from '../types/funnel';

export interface PricingConfig {
  version: string;
  ratesApproved: boolean;
  /** Approved standard hourly rates: whole crew + 1 truck. */
  rates: Record<number, number>;
  /** Admin-only negotiation floors. Server-authorized; never exposed to customers. */
  negotiationFloors: Record<number, number>;
  minimumServiceHours: number;
  travelHours: number;
  surchargePercent: number;
  surchargeBaseApproved: boolean;
  baseHoursByBedroom: Record<Bedrooms, number>;
  stairsUpliftHours: { second: number; third: number };
  elevatorAllowanceHours: number;
  carryPlanningHours: Record<CarryBand, number>;
  packingCrewHoursPer10Boxes: number;
  rangeSpreadHours: number;
  depositAmount: number;
  cancellationNoticeHours: number;
  refundLanguageApproved: boolean;
  cardFeeConfigured: boolean;
  /** Approved card payment charge, applied only to amounts paid by card. */
  cardFeePercent: number;
}

export const defaultPricingConfig: PricingConfig = {
  version: 'rates-2026-10-06.2',
  ratesApproved: true,
  rates: { 2: 129, 3: 159 },
  negotiationFloors: { 2: 90, 3: 129 },
  minimumServiceHours: 4,
  travelHours: 1,
  surchargePercent: 20,
  surchargeBaseApproved: false,
  baseHoursByBedroom: { studio: 4, '1': 4, '2': 5, '3': 7, '4': 10, '5': 12, few: 4 },
  stairsUpliftHours: { second: 1, third: 2 },
  elevatorAllowanceHours: 0.75,
  carryPlanningHours: { '0_20': 0, '21_40': 0, '41_60': 0.25, '61_100': 0.5, over_100: 0.75, unsure: 0.25 },
  packingCrewHoursPer10Boxes: 1,
  rangeSpreadHours: 1,
  depositAmount: 99,
  cancellationNoticeHours: 72,
  refundLanguageApproved: false,
  cardFeeConfigured: true,
  cardFeePercent: 4,
};

export const pricingOpenItems = [
  '20% operating surcharge: the calculation base (labor only? labor + travel? before or after extras?) is still not defined, so no surcharge amount or final estimated total is shown.',
  '4% card charge: approved. It must also be configured in the Stripe/processor checkout so the charged amount matches the estimate line.',
  'Negotiated rates ($119/$109/$99/$90 for 2 movers on eligible weekdays; 3 movers to $129) need a backend eligibility check and server-issued quote ID. Not applied in the browser.',
  'Transportation pricing for extended corridors and Miami: no approved formula. The 1 local travel hour does not cover those routes.',
  'Refund exceptions for the 72-hour cancellation/reschedule rule must come from the approved contract.',
  'Packing/materials catalog prices not approved, shown as “priced by our team”.',
  'Long-carry threshold, stair or access fees: none approved, so none charged.',
];
